<script>
import {mapState, mapActions} from 'vuex';

export default {
    props: {
        action: {
            type: String,
            required: true,
        }
    },
    computed: {
        ...mapState({
            submitted: state => state.admin.editModal.form.submitted,
            accepted: state => state.admin.editModal.form.accepted,
        }),
    },
    methods: {
        ...mapActions({
            acceptEditUserForm: 'admin/acceptEditUserForm',
            cancelEditUserForm: 'admin/cancelEditUserForm',
        }),
        accept() {
            this.acceptEditUserForm();
            this.$emit('accept');
        },
        close($event) {
            if ($event.target.id === 'container') {
                this.cancelEditUserForm();
            }
        }
    }
}
</script>
<template>
    <div class="admin-edit-modal-form-accept">
        <transition name="fade" mode="out-in">
            <div v-if="submitted" id="container" class="admin-edit-modal-form-accept__container" @click="close($event)">
                <div class="admin-edit-modal-form-accept__body">
                    <div class="admin-edit-modal-form-accept__header">
                        {{ $t('admin.edit.accept.header.' + action) }}
                    </div>
                    <div class="admin-edit-modal-form-accept__content">
                        {{ $t('admin.edit.accept.content.' + action) }}
                    </div>
                    <div class="admin-edit-modal-form-accept__button-group">
                        <button class="admin-edit-modal-form-accept__submit" @click="accept">
                            {{ $t('admin.edit.accept.buttons.accept') }}
                        </button>
                        <button class="admin-edit-modal-form-accept__cancel" @click="cancelEditUserForm">
                            {{ $t('admin.edit.accept.buttons.cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AdminEditModalFormAccept/AdminEditModalFormAccept.vue